module.exports = __webpack_public_path__ + "static/media/calendar-plus.2e15555d.svg";